// src/components/ThirdPartyContact/Components/ThirdPartyContactEndpointStep.js
import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const ThirdPartyContactEndpointStep = ({
  ephemeralRows,
  formErrors,
  handleEphemeralRowChange,
  handleAddEndpoint,
  handleRemoveEndpoint,
  channelOptions,
}) => {
  const theme = useTheme();
  return (
    <Box mt={2}>
      {formErrors.endpoints && (
        <FormHelperText error>{formErrors.endpoints}</FormHelperText>
      )}
      {ephemeralRows.map((row, index) => (
        <Box
          key={row.id}
          display="flex"
          alignItems="flex-end"
          gap={2}
          sx={{ mb: 2 }}
        >
          <FormControl sx={{ minWidth: 180 }}>
            <FormLabel>Channel</FormLabel>
            <Select
              value={row.channel}
              onChange={(e) =>
                handleEphemeralRowChange(index, "channel", e.target.value)
              }
              displayEmpty
              disabled={row.added}
            >
              <MenuItem value="">
                <em>Select Channel</em>
              </MenuItem>
              {channelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ flex: 2, minWidth: 220 }}>
            <FormLabel>Identifier</FormLabel>
            <TextField
              placeholder="Enter Identifier"
              value={row.identifier}
              onChange={(e) =>
                handleEphemeralRowChange(index, "identifier", e.target.value)
              }
              disabled={row.added}
            />
          </FormControl>
          <IconButton
            color={
              row.added
                ? "success"
                : !row.added && row.channel && row.identifier
                ? "primary"
                : "default"
            }
            sx={{
              ...(!row.added && row.channel && row.identifier
                ? { boxShadow: 3, border: `2px solid ${theme.palette.text.secondary}` }
                : {}),
              alignSelf: 'flex-start',
              mt: '26px', // Adjust this value as needed for perfect alignment
            }}
            onClick={() => {
              if (!row.added) {
                handleAddEndpoint(index);
              }
            }}
          >
            {row.added ? <CheckIcon sx={{ color: "green" }} /> : <AddIcon sx={{ color: theme.palette.text.secondary }} />}
          </IconButton>
          {row.added && (
            <IconButton
              color="error"
              onClick={() => handleRemoveEndpoint(index)}
              sx={{ alignSelf: 'flex-start', mt: '26px', color: theme.palette.text.secondary }}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default ThirdPartyContactEndpointStep;
